import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m4.163 9.527-.194.2v-5.06a.667.667 0 1 0-1.333 0v5.06l-.193-.2a.67.67 0 0 0-.947.946l1.333 1.334q.097.091.22.14a.63.63 0 0 0 .507 0 .7.7 0 0 0 .22-.14l1.333-1.334a.669.669 0 1 0-.946-.946m3.14-4.194h6.666a.666.666 0 1 0 0-1.333H7.303a.667.667 0 0 0 0 1.333m6.666 2H7.303a.667.667 0 0 0 0 1.334h6.666a.666.666 0 1 0 0-1.334m0 3.334H7.303a.667.667 0 1 0 0 1.333h6.666a.666.666 0 1 0 0-1.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })